<template>
    <div>
      <page-header
        left-side-class="col-12 col-md-7"
        :page="headerConfig"
        right-side-class="col-12 col-md-5"
        class="mt-3 mt-md-0"
        @onReturn="() => $router.back()"
        :has-return="true"
      />
  
      <div class="row">
        <div class="col-6">
          <filter-manager
            :display-advanced="false"
            class="search-bar"
            items-container-class="flex-wrap"
            search-icon="fa fa-sync"
            search-text="Procesar"
            search-container-class="btn-process"
            v-model="model.search.filters"
            :filters="filterManagerConfig"
            @search="process"
            ref="filterRef"
          />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import PageHeader from "PageHeader";
  import FilterManager from "FilterManager";
  import ReportServices from '@/modules/report/api';
  import DocumentServices from '@//modules/report/document'
  
  export default {
    name: "PEIStudentsABAService",
    components: {
      PageHeader,
      FilterManager,
    },
    data: () => ({    
      model: {
       defaultService: { id: 0, name: 'ABA'},
       search: {
         filters: {
         },
       }
      }
    }),
    computed: {
      headerConfig() {
        return {
          title: 'Informe de Estudiantes con Servicios de ABA',
          icon:
            'fas fa-chart-pie',
          routes: ['Informes', 'Informe de Estudiantes con Servicios de ABA'],
        }
      },
      filterManagerConfig() {
        return [
          {
            name: 'service',
            component: 'custom-drop-down',
            fieldKey: 'id',
            fieldName: 'name',
            label: 'Servicio:',
            placeholder: 'Seleccionar',
            error: 'Favor seleccionar un servicio.',
            validations: 'required',
            class: 'col-md-6',
            clearable: false,
            disabled: true,
            options: [this.model.defaultService],
            value: this.model.defaultService,                  
          },   
        ]   
      }
    },
    async mounted() {
      this.model.search.filters.service = this.model.defaultService;
    },
    methods: {
      async process() {
        await ReportServices.getReport('peistudentsabaservice').then((res) => DocumentServices.Download(res.data));
      },
    },
  }
  </script>